import { htmlToText } from 'utils/html';
import { isEmpty } from 'utils/string';
import NormControl_Translation from './normControl_Translation';
import { IOwner } from './owner';

export default class NormControl implements IOwner {
  normId: number;

  controlId: number;

  ownerId?: string;

  ownerRoleId?: string;

  groupId?: string;

  trans?: NormControl_Translation[];

  transIdx: number;

  //translation properties are flattened on the main class for the current language of the user
  implementation?: string;

  constructor() {
    this.normId = 0;
    this.controlId = 0;
    this.transIdx = -1;
  }

  static isEqualList = (a: NormControl[] | undefined, b: NormControl[] | undefined): boolean => {
    const listA = a ?? [];
    const listB = b ?? [];
    if (listA.length !== listB.length) return false;

    for (const item of listA) {
      const match = listB.find((i) => i.normId === item.normId);
      if (!match || !item.isEqual(match)) return false;
    }

    return true;
  };

  static getEffectiveOwnerSource = (defaults: IOwner, entry: NormControl | undefined): IOwner => {
    return entry?.ownerId || entry?.ownerRoleId ? entry : defaults;
  };

  static getEffectiveGroupId = (defaults: { groupId?: string }, entry: NormControl | undefined): string | undefined => {
    return entry?.groupId ?? defaults.groupId;
  };

  //ensure the entry has a translation row for the given language, so a flattened implementation edit can be persisted
  static ensureTrans = (entry: NormControl, languageId: number): void => {
    if (entry.trans && entry.trans.length > 0) return;

    const newTrans = new NormControl_Translation();
    newTrans.normId = entry.normId;
    newTrans.controlId = entry.controlId;
    newTrans.languageId = languageId;
    entry.trans = [newTrans];
    entry.transIdx = 0;
  };

  hasData(): boolean {
    if (this.ownerId) return true;
    if (this.ownerRoleId) return true;
    if (this.groupId) return true;
    if (!isEmpty(htmlToText(this.implementation))) return true;

    return false;
  }

  isEqual(item: NormControl): boolean {
    if (item.normId !== this.normId) return false;
    if (item.ownerId !== this.ownerId) return false;
    if (item.ownerRoleId !== this.ownerRoleId) return false;
    if (item.groupId !== this.groupId) return false;
    if (item.implementation !== this.implementation) return false;

    return true;
  }

  clone(): NormControl {
    const newItem = new NormControl();

    newItem.normId = this.normId;
    newItem.controlId = this.controlId;
    newItem.ownerId = this.ownerId;
    newItem.ownerRoleId = this.ownerRoleId;
    newItem.groupId = this.groupId;
    newItem.transIdx = this.transIdx;
    newItem.trans = this.trans?.map((t) => Object.assign(new NormControl_Translation(), t));
    newItem.implementation = this.implementation;

    return newItem;
  }
}
